module.exports = __webpack_public_path__ + "static/UnclickOverseas-004437534728c2d1fd823fd6a167e290.png";